'use strict'
import { Icon } from "./icon.js"
import { UI } from '../lib/ui.js'
export class Table {
    constructor(table = null) {
        window.ui = window.ui ? window.ui : new UI()
        this.table = table
        if(Array.isArray(table)){
            this.table = this.create(table)
        }
       
        this.data = table?.dataset 
        this.header = (()=>table?.querySelector('thead'))()
        this.headers = (()=>table?.querySelectorAll('th'))()
        this.body = (()=>table?.querySelector('tbody'))()
        this.rows = (()=>table?.querySelectorAll('tbody tr'))()
        this.cells = (()=>table?.querySelectorAll('tbody td'))()
        if(table) this.sort()
        if(table) this.filter()
        if(table) this.format()
    }
    /**
     * Makes table column rows sortable on header click
     */
    sort(){
        const directions = Array.from(this.headers).map(() => ''),
              transform = (index, content) => {
                const type = this.headers[index].dataset.type ? this.headers[index].dataset.type : ''
                switch (type) {
                    case 'number':
                        return parseFloat(content.textContent)
                    case 'switch':
                        return content.querySelector('input').getAttribute('value')
                    case 'string':
                    default:
                        return content.textContent
                }           
              },
              sortColumn = index => {
                const direction = directions[index] || 'asc',
                      multiplier = direction === 'asc' ? 1 : -1,
                      newRows = Array.from(this.rows)
                newRows.sort(function (rowA, rowB) {
                    const cellA = rowA.querySelectorAll('td')[index],
                          cellB = rowB.querySelectorAll('td')[index],
                          a = transform(index, cellA),
                          b = transform(index, cellB)
            
                    switch (true) {
                        case a > b:
                            return 1 * multiplier
                        case a < b:
                            return -1 * multiplier
                        case a === b:
                            return 0
                    }
                })
                this.rows.forEach( row => this.body.removeChild(row))
                directions[index] = direction === 'asc' ? 'desc' : 'asc'
                newRows.forEach(newRow => this.body.appendChild(newRow))
              },
              icons = {
                  asc : 'sort-up',
                  desc : 'sort-down'
              }

        this.headers.forEach((header, index) => {
            header.addEventListener('click',  () => {
                
                //if(!header.dataset?.disable === 'sort'){
                  
                    Array.from(this.headers).forEach((header)=> {
                        const icon = header.querySelector('.svg-inline--fa')
                        if(icon)
                            icon.remove()
                    })
                    sortColumn(index)
                    header.innerHTML += ' <i class="fa-solid fa-'+icons[directions[index]]+'"></i>'
                    header.append(new Icon(icons[directions[index]]))
                //}
                
            })
        })
    }
    /**
     * Formats table cells depending on data-type attribute
     */
    format(){
        this.cells.forEach((cell)=>{
            const type = cell.dataset.type,
                  content = cell.textContent
            switch (type) {
                case 'boolean':
                    if(content === 1){
                        cell.innerHTML = '<i class="fa-solid fa-check"></i>'
                    }else{
                        cell.textContent = ''
                    }
                    break

                default:
                    break
            }
        })
    }
    /**
     * Adds filter input to filter text contents of table rows
     */
    filter(){

        const filterInput = () => {
            
            const ui = window.ui ? window.ui : new UI
            const rowElement = this.table.dataset.filterContainer 
                ? ui.element(this.table.dataset.filterContainer) 
                : ui.element('div', {
                    class:'row',
                    style:'float:right;margin-top: -75px;'
                  }),
                  colElement = ui.element('div', {
                    class:'col'
                  }),
                  inputElement = ui.element('input', {
                    class:'form-control',
                    style:'width:unset;margin:1em;margin-top:-10px;padding-left:35px;',
                    placeholder:__('Filter Display')
                  }),
                  iconElement = new Icon('solid-filter', {
                      style:'margin-bottom:-20px;margin-left:30px;'
                  })
            //rowElement.classList.add('row')
            //colElement.classList.add('col')
            //iconElement.setAttribute('class','fa-solid fa-filter')
            //iconElement.setAttribute('style','margin-bottom:-20px;margin-left:30px;')
            //inputElement.classList.add('form-control')
            //inputElement.setAttribute('style','width:unset;margin:1em;margin-top:-10px;padding-left:35px;')
            //inputElement.setAttribute('placeholder','Filter weergave')
            //rowElement.setAttribute('style','float:right;margin-top:-75px;')
            colElement.append(inputElement)
            rowElement.append(colElement)
            inputElement.parentNode.insertBefore(iconElement, inputElement)
            this.table.parentNode.insertBefore(rowElement, this.table)
            return inputElement
        }
        filterInput().addEventListener('input',(event)=>{
            const searchValue = event.target.value
            Array.from(this.rows).forEach( row => {
                row.classList.remove('hide')
                if(!row.textContent.toLowerCase().includes(searchValue.toLowerCase())){
                    row.classList.add('hide')
                }
            })
        })
        
    }
    /**
     * Adds pagination to table 
     */
    paginate(){
        const tableRows = this.table.querySelectorAll('tr'),
              tableRowCount = tableRows.length,
              itemsPerPage = 10
        this.showRecords = function (from, to) {
            
            for (let i = 1; i < this.rows.length; i++) {
                if (i < from || i > to) {
                    this.rows[i].style.display = 'none'
                } else {
                    this.rows[i].style.display = ''
                }
            }
        }
        this.showPage = function (pageNumber) {
            if (!this.inited)
                return;
            let oldPageAnchor = document.getElementById('pg' + this.currentPage)
            oldPageAnchor.className = 'pg-normal'
            this.currentPage = pageNumber
            let newPageAnchor = document.getElementById('pg' + this.currentPage)
            newPageAnchor.className = 'pg-selected'
            let from = (pageNumber - 1) * itemsPerPage + 1
            let to = from + itemsPerPage - 1
            this.showRecords(from, to)
            let pgNext = document.querySelector('.pg-next'),
                pgPrev = document.querySelector('.pg-prev')
            if (this.currentPage == this.pages) {
                pgNext.style.display = 'none'
            } else {
                pgNext.style.display = ''
            }
            if (this.currentPage === 1) {
                pgPrev.style.display = 'none'
            } else {
                pgPrev.style.display = ''
            }
        }
        this.prev = function () {
            if (this.currentPage > 1) {
                this.showPage(this.currentPage - 1)
            }
        }
        this.next = function () {
            if (this.currentPage < this.pages) {
                this.showPage(this.currentPage + 1)
            }
        };
        this.init = function () {
            let rows = this.rows
            let records = (rows.length - 1)

            this.pages = Math.ceil(records / itemsPerPage)
            this.inited = true;
        };
        this.showPageNav = function (pagerName, positionId) {
            if (!this.inited) {
                // Not initialized
                return
            }
            const pagerElement = document.createElement('ul'),
                  pageElement = ( content ) => {
                      const element = document.createElement('li')
                      element.classList.add('page-item')
                      element.append(content)
                      return element
                  },
                  pageLink = ( content ) => {
                      const element = document.createElement('a')
                      element.classList.add('page-link')
                      element.innerHTML = content
                      return pageElement(element)
                  }

            pagerElement.classList.add('pagination')
            pagerElement.append(pageLink())
            let element = document.getElementById(positionId),
                pagerHtml = '<span onclick="' + pagerName + '.prev();" class="pg-normal pg-prev">«</span>'

            for (let page = 1; page <= this.pages; page++) {
                pagerHtml += '<span id="pg' + page + '" class="pg-normal pg-next" onclick="' + pagerName + '.showPage(' + page + ');">' + page + '</span>'
            }
            pagerHtml += '<span onclick="' + pagerName + '.next();" class="pg-normal">»</span>'
            element.innerHTML = pagerHtml
        }
    }
    /**
     * Provide actions callback for elements in .actions depending data-action attribute
     */
    actions(callback){
        setTimeout(()=>{
            const tableActions = this.table.querySelectorAll('td.actions span')
            tableActions.forEach((element)=>{

                Array.from(element.children).forEach((element)=>{
                    const data = element.dataset,
                    action = data.action
                    element.addEventListener('click',()=>{
                         if(action)
                             callback(element)
                    })
                })
            })
        },200)
    }
    /**
     * 
     * @param {*} data 
     * @returns 
     */
    create(data){
        const ui = window.ui ? window.ui : new UI,
              table = ui.element('table',{class:'table'}),
              thead = ui.element('thead',{class:'thead'}),
              tbody = ui.element('tbody',{class:'tbody'})
        Object.keys(data[0]).forEach( item => {
            thead.append(ui.element('th',data[0][item]))
        })
        data.forEach(item => {
            const tr =  ui.element('tr',{class:'row'})
            if(item.id)
                ui.element(tr,{id:item.id})
            Object.keys(item).forEach(key => {
                tr.append(ui.element('tr',{class:'cell'},item[key]))
            })
            tbody.append(tr)
        })
        table.append(thead)
        table.append(tbody)
        return table
    }
    /**
     * 
     */
    changeable(){
        this.headers.forEach((header) => {
            if(header.dataset.action === 'change'){
                header.setAttribute('data-bs-toggle')
                header.addEventListener('click',(event) => {
                
                
                })
            }
            
        })
    }
    /**
     * 
     */
    editable(){
        this.cells.forEach(cell => {

        })
    }
}